import type { ClerkProvider } from '@clerk/nextjs'
import type { ComponentProps } from 'react'
import type { Locale } from './config'

/** Clerk's UI strings for one language (`@clerk/localizations`). */
export type ClerkLocalization = NonNullable<
  ComponentProps<typeof ClerkProvider>['localization']
>

/** English is Clerk's built-in default. */
export type TranslatedLocale = Exclude<Locale, 'en'>

/**
 * Clerk's own translation for each other app locale. Each loads only when a
 * page in its locale renders: on the server for the localized tree
 * (`getClerkLocalization`), in the browser for the product roots
 * (`ProductClerkLocalization`). One explicit `import()` per locale, never a
 * template.
 */
export const CLERK_LOCALIZATIONS: Readonly<
  Record<TranslatedLocale, () => Promise<ClerkLocalization>>
> = {
  de: async () => (await import('@clerk/localizations/de-DE')).deDE,
  fr: async () => (await import('@clerk/localizations/fr-FR')).frFR,
  es: async () => (await import('@clerk/localizations/es-ES')).esES,
  'pt-br': async () => (await import('@clerk/localizations/pt-BR')).ptBR,
  it: async () => (await import('@clerk/localizations/it-IT')).itIT,
  nl: async () => (await import('@clerk/localizations/nl-NL')).nlNL,
  pl: async () => (await import('@clerk/localizations/pl-PL')).plPL,
  sv: async () => (await import('@clerk/localizations/sv-SE')).svSE,
  cs: async () => (await import('@clerk/localizations/cs-CZ')).csCZ,
  tr: async () => (await import('@clerk/localizations/tr-TR')).trTR,
  ja: async () => (await import('@clerk/localizations/ja-JP')).jaJP,
  ko: async () => (await import('@clerk/localizations/ko-KR')).koKR,
  th: async () => (await import('@clerk/localizations/th-TH')).thTH,
  vi: async () => (await import('@clerk/localizations/vi-VN')).viVN,
  id: async () => (await import('@clerk/localizations/id-ID')).idID,
}
